import React, { useRef, useEffect, useMemo } from "react";
import { Stage, Layer, Text, Transformer, Image } from "react-konva";
import MyImage from "./MyImage";
import useImage from "../useImage";

// دالة حماية القيم العددية
function safeNum(v, fallback = 10) {
  return Number.isFinite(v) && !isNaN(v) ? v : fallback;
}

// مكون خلفية النص
function TextBackground({ layer, padding, radius, bgOpacity, setSelectedId, updateLayer }) {
  const [bgImage] = useImage(layer.backgroundImage || '');
  
  // إذا كان النوع لون، اعرض المستطيل
  if (layer.backgroundType === "color") {
    return (
      <rect
        x={safeNum(layer.x, 100) - padding}
        y={safeNum(layer.y, 100) - padding}
        width={safeNum(layer.width, 350) + (padding * 2)}
        height={safeNum(layer.height, 80) + (padding * 2)}
        fill={layer.backgroundColor || "#000000"}
        opacity={bgOpacity * safeNum(layer.opacity, 1)}
        rotation={safeNum(layer.rotation, 0)}
        cornerRadius={radius}
        draggable
        onClick={() => setSelectedId(layer.id)}
        onTap={() => setSelectedId(layer.id)}
        onMouseEnter={e => {
          e.target.getStage().container().style.cursor = 'move';
        }}
        onMouseLeave={e => {
          e.target.getStage().container().style.cursor = 'default';
        }}
        onTransformEnd={e => {
          const node = e.target;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          let width = safeNum(node.width() * scaleX, 10);
          let height = safeNum(node.height() * scaleY, 10);
          updateLayer(layer.id, {
            x: safeNum(node.x(), 100) + padding,
            y: safeNum(node.y(), 100) + padding,
            width: width - (padding * 2),
            height: height - (padding * 2),
            rotation: safeNum(node.rotation(), 0),
          });
          node.scaleX(1); node.scaleY(1);
        }}
        onDragMove={e => updateLayer(layer.id, { 
          x: safeNum(e.target.x(), 100) + padding, 
          y: safeNum(e.target.y(), 100) + padding 
        })}
        onDragEnd={e => updateLayer(layer.id, { 
          x: safeNum(e.target.x(), 100) + padding, 
          y: safeNum(e.target.y(), 100) + padding 
        })}
        perfectDrawEnabled={false}
        listening={true}
      />
    );
  }
  
  // إذا كان النوع صورة وكانت الصورة محملة، اعرض الصورة
  if (layer.backgroundType === "image" && bgImage) {
    return (
      <Image
        image={bgImage}
        x={safeNum(layer.x, 100) - padding}
        y={safeNum(layer.y, 100) - padding}
        width={safeNum(layer.width, 350) + (padding * 2)}
        height={safeNum(layer.height, 80) + (padding * 2)}
        opacity={bgOpacity * safeNum(layer.opacity, 1)}
        rotation={safeNum(layer.rotation, 0)}
        cornerRadius={radius}
        draggable
        onClick={() => setSelectedId(layer.id)}
        onTap={() => setSelectedId(layer.id)}
        onMouseEnter={e => {
          e.target.getStage().container().style.cursor = 'move';
        }}
        onMouseLeave={e => {
          e.target.getStage().container().style.cursor = 'default';
        }}
        onTransformEnd={e => {
          const node = e.target;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          let width = safeNum(node.width() * scaleX, 10);
          let height = safeNum(node.height() * scaleY, 10);
          updateLayer(layer.id, {
            x: safeNum(node.x(), 100) + padding,
            y: safeNum(node.y(), 100) + padding,
            width: width - (padding * 2),
            height: height - (padding * 2),
            rotation: safeNum(node.rotation(), 0),
          });
          node.scaleX(1); node.scaleY(1);
        }}
        onDragMove={e => updateLayer(layer.id, { 
          x: safeNum(e.target.x(), 100) + padding, 
          y: safeNum(e.target.y(), 100) + padding 
        })}
        onDragEnd={e => updateLayer(layer.id, { 
          x: safeNum(e.target.x(), 100) + padding, 
          y: safeNum(e.target.y(), 100) + padding 
        })}
        perfectDrawEnabled={false}
        listening={true}
      />
    );
  }
  
  // إذا كان النوع صورة ولكن الصورة لم تُحمل بعد، اعرض مستطيل مؤقت
  if (layer.backgroundType === "image") {
    return (
      <rect
        x={safeNum(layer.x, 100) - padding}
        y={safeNum(layer.y, 100) - padding}
        width={safeNum(layer.width, 350) + (padding * 2)}
        height={safeNum(layer.height, 80) + (padding * 2)}
        fill="#f0f0f0"
        opacity={bgOpacity * safeNum(layer.opacity, 1)}
        rotation={safeNum(layer.rotation, 0)}
        cornerRadius={radius}
        draggable
        onClick={() => setSelectedId(layer.id)}
        onTap={() => setSelectedId(layer.id)}
        onMouseEnter={e => {
          e.target.getStage().container().style.cursor = 'move';
        }}
        onMouseLeave={e => {
          e.target.getStage().container().style.cursor = 'default';
        }}
        onTransformEnd={e => {
          const node = e.target;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          let width = safeNum(node.width() * scaleX, 10);
          let height = safeNum(node.height() * scaleY, 10);
          updateLayer(layer.id, {
            x: safeNum(node.x(), 100) + padding,
            y: safeNum(node.y(), 100) + padding,
            width: width - (padding * 2),
            height: height - (padding * 2),
            rotation: safeNum(node.rotation(), 0),
          });
          node.scaleX(1); node.scaleY(1);
        }}
        onDragMove={e => updateLayer(layer.id, { 
          x: safeNum(e.target.x(), 100) + padding, 
          y: safeNum(e.target.y(), 100) + padding 
        })}
        onDragEnd={e => updateLayer(layer.id, { 
          x: safeNum(e.target.x(), 100) + padding, 
          y: safeNum(e.target.y(), 100) + padding 
        })}
        perfectDrawEnabled={false}
        listening={true}
      />
    );
  }
  
  return null;
}

export default function CanvasPreview({ canvas, selectedId, setSelectedId, updateLayer }) {
  const transformerRef = useRef();
  const layerRefs = useRef({});

  // التأكد من وجود layers باستخدام useMemo
  const layers = useMemo(() => canvas?.layers || [], [canvas?.layers]);

  useEffect(() => {
    if (selectedId && transformerRef.current && layerRefs.current[selectedId]) {
      transformerRef.current.nodes([layerRefs.current[selectedId]]);
      transformerRef.current.getLayer().batchDraw();
    } else if (transformerRef.current) {
      transformerRef.current.nodes([]);
      transformerRef.current.getLayer().batchDraw();
    }
  }, [selectedId, layers]);

  // التأكد من وجود canvas
  if (!canvas) {
    return (
      <div style={{
        border: "2px solid var(--border-color)", 
        margin: "16px 0",
        borderRadius: 14, 
        background: "transparent",
        position: "relative",
        width: 1280, 
        height: 720, 
        overflow: "hidden",
        boxShadow: "0 4px 20px var(--shadow-color)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "var(--text-secondary)"
      }}>
        جاري التحميل...
      </div>
    );
  }

  // دالة للتحقق من رؤية الطبقة بناءً على المجموعات
  const isLayerVisible = (layer) => {
    // إذا كانت الطبقة مخفية مباشرة، ارجع false
    if (layer.visible === false) return false;
    
    // تحقق من المجموعات
    const layerGroups = canvas.groups?.filter(group => group.layers && group.layers.includes(layer.id)) || [];
    
    // إذا كانت الطبقة في مجموعة مخفية، ارجع false
    for (const group of layerGroups) {
      if (group.visible === false) return false;
    }
    
    return true;
  };

  return (
    <div style={{
      border: "2px solid var(--border-color)", 
      margin: "16px 0",
      borderRadius: 14, 
      background: "transparent",
      position: "relative",
      width: canvas.width, 
      height: canvas.height, 
      overflow: "hidden",
      boxShadow: "0 4px 20px var(--shadow-color)",
      backdropFilter: "none",
      WebkitBackdropFilter: "none"
    }} className="canvas-preview">
      {/* معلومات debug للخلفية */}
      {process.env.NODE_ENV === 'development' && (
        <div style={{
          position: "absolute",
          top: "5px",
          left: "5px",
          background: "rgba(0,0,0,0.8)",
          color: "white",
          padding: "8px",
          fontSize: "11px",
          zIndex: 1000,
          borderRadius: "4px",
          fontFamily: "monospace"
        }}>
          <div>نوع: {canvas.backgroundType}</div>
          <div>شفافة: {canvas.transparentBackground ? 'نعم' : 'لا'}</div>
          <div>قيمة: {canvas.backgroundValue || 'فارغة'}</div>
          <div>شفافية: {canvas.opacity || 1}</div>
        </div>
      )}
      
      {/* الخلفية - تظهر فقط إذا كان النوع ليس "none" وكانت الشفافية معطلة أو كان النوع مختلف عن "none" */}
      {canvas.backgroundType !== "none" && canvas.backgroundValue && (
        <>
          {canvas.backgroundType === "gradient" && (
            <div style={{
              position: "absolute", inset: 0, zIndex: 0,
              background: `linear-gradient(${canvas.gradient.angle}deg, ${canvas.gradient.from}, ${canvas.gradient.to})`,
              width: "100%", height: "100%", opacity: canvas.opacity || 1
            }} />
          )}
          {canvas.backgroundType === "color" && (
            <div style={{
              background: canvas.backgroundValue, width: canvas.width, height: canvas.height,
              position: "absolute", zIndex: 0, opacity: canvas.opacity || 1
            }} />
          )}
          {canvas.backgroundType === "image" && (
            <img
              src={canvas.backgroundValue}
              style={{
                position: "absolute", width: canvas.width, height: canvas.height,
                objectFit: "cover", zIndex: 0, opacity: canvas.opacity || 1
              }}
              alt="bg"
              onError={(e) => console.error('خطأ في تحميل صورة الخلفية:', e)}
            />
          )}
          {canvas.backgroundType === "video" && (
            <video
              src={canvas.backgroundValue}
              autoPlay loop muted playsInline
              style={{
                position: "absolute", width: canvas.width, height: canvas.height,
                objectFit: "cover", zIndex: 0, opacity: canvas.opacity || 1
              }}
              onError={(e) => console.error('خطأ في تحميل فيديو الخلفية:', e)}
            />
          )}
        </>
      )}

      {/* عناصر الفيديو HTML */}
      {layers.filter(l => l.type === "video" && isLayerVisible(l)).map(layer => (
        <video
          key={`video-${layer.id}`}
          src={layer.content}
          autoPlay loop muted playsInline
          style={{
            position: "absolute",
            left: safeNum(layer.x, 100),
            top: safeNum(layer.y, 100),
            width: safeNum(layer.width, 320),
            height: safeNum(layer.height, 180),
            opacity: safeNum(layer.opacity, 1),
            zIndex: 2,
            borderRadius: 8,
            transform: `rotate(${safeNum(layer.rotation, 0)}deg)`,
            transformOrigin: "center center",
            pointerEvents: "none"
          }}
        />
      ))}

      {/* فيديو خلفية النص */}
      {layers.filter(l => l.type === "text" && l.backgroundType === "video" && l.backgroundVideo && isLayerVisible(l)).map(layer => {
        const padding = safeNum(layer.backgroundPadding, 10);
        const bgOpacity = safeNum(layer.backgroundOpacity, 1);
        
        return (
          <video
            key={`text-bg-video-${layer.id}`}
            src={layer.backgroundVideo}
            autoPlay loop muted playsInline
            style={{
              position: "absolute",
              left: safeNum(layer.x, 100) - padding,
              top: safeNum(layer.y, 100) - padding,
              width: safeNum(layer.width, 350) + (padding * 2),
              height: safeNum(layer.height, 80) + (padding * 2),
              opacity: bgOpacity * safeNum(layer.opacity, 1),
              zIndex: 1,
              borderRadius: safeNum(layer.backgroundRadius, 0),
              transform: `rotate(${safeNum(layer.rotation, 0)}deg)`,
              transformOrigin: "center center",
              pointerEvents: "none"
            }}
          />
        );
      })}

      <Stage
        width={canvas.width}
        height={canvas.height}
        style={{ background: "transparent", position: "relative", zIndex: 1 }}
        onMouseDown={e => {
          if (e.target === e.target.getStage()) setSelectedId(null);
        }}
      >
        <Layer>
          {layers.map((layer) => {
            // ---- TEXT ----
            if (layer.type === "text" && isLayerVisible(layer)) {
              const padding = safeNum(layer.backgroundPadding, 10);
              const radius = safeNum(layer.backgroundRadius, 0);
              const bgOpacity = safeNum(layer.backgroundOpacity, 1);
              
              return (
                <React.Fragment key={layer.id}>
                  {/* خلفية النص */}
                  {(layer.backgroundType === "color" || layer.backgroundType === "image") && (
                    <TextBackground
                      layer={layer}
                      padding={padding}
                      radius={radius}
                      bgOpacity={bgOpacity}
                      setSelectedId={setSelectedId}
                      updateLayer={updateLayer}
                    />
                  )}
                  
                  {/* النص */}
                  <Text
                    ref={node => layerRefs.current[layer.id] = node}
                    x={safeNum(layer.x, 100)}
                    y={safeNum(layer.y, 100)}
                    width={safeNum(layer.width, 350)}
                    height={safeNum(layer.height, 80)}
                    draggable
                    text={layer.content}
                    fontFamily={layer.font}
                    fontSize={safeNum(layer.fontSize, 56)}
                    fontStyle={layer.fontWeight}
                    fill={layer.color}
                    opacity={safeNum(layer.opacity, 1)}
                    rotation={safeNum(layer.rotation, 0)}
                    onClick={() => setSelectedId(layer.id)}
                    onTap={() => setSelectedId(layer.id)}
                    onMouseEnter={e => {
                      e.target.getStage().container().style.cursor = 'move';
                    }}
                    onMouseLeave={e => {
                      e.target.getStage().container().style.cursor = 'default';
                    }}
                    onTransformEnd={e => {
                      const node = e.target;
                      const scaleX = node.scaleX();
                      const scaleY = node.scaleY();
                      let width = safeNum(node.width() * scaleX, 10);
                      let height = safeNum(node.height() * scaleY, 10);
                      updateLayer(layer.id, {
                        x: safeNum(node.x(), 100),
                        y: safeNum(node.y(), 100),
                        width,
                        height,
                        rotation: safeNum(node.rotation(), 0),
                      });
                      node.scaleX(1); node.scaleY(1);
                    }}
                    onDragMove={e => updateLayer(layer.id, { x: safeNum(e.target.x(), 100), y: safeNum(e.target.y(), 100) })}
                    onDragEnd={e => updateLayer(layer.id, { x: safeNum(e.target.x(), 100), y: safeNum(e.target.y(), 100) })}
                    perfectDrawEnabled={false}
                    listening={true}
                  />
                </React.Fragment>
              );
            }
            // ---- IMAGE ----
            if (layer.type === "image" && isLayerVisible(layer)) {
              return (
                <MyImage
                  key={layer.id}
                  ref={node => layerRefs.current[layer.id] = node}
                  src={layer.content}
                  x={safeNum(layer.x, 100)}
                  y={safeNum(layer.y, 100)}
                  width={safeNum(layer.width, 320)}
                  height={safeNum(layer.height, 180)}
                  draggable
                  opacity={safeNum(layer.opacity, 1)}
                  rotation={safeNum(layer.rotation, 0)}
                  onClick={() => setSelectedId(layer.id)}
                  onTap={() => setSelectedId(layer.id)}
                  onMouseEnter={e => {
                    e.target.getStage().container().style.cursor = 'move';
                  }}
                  onMouseLeave={e => {
                    e.target.getStage().container().style.cursor = 'default';
                  }}
                  onTransformEnd={e => {
                    const node = e.target;
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();
                    let width = safeNum(node.width() * scaleX, 10);
                    let height = safeNum(node.height() * scaleY, 10);
                    updateLayer(layer.id, {
                      x: safeNum(node.x(), 100),
                      y: safeNum(node.y(), 100),
                      width,
                      height,
                      rotation: safeNum(node.rotation(), 0),
                    });
                    node.scaleX(1); node.scaleY(1);
                  }}
                  onDragMove={e => updateLayer(layer.id, { x: safeNum(e.target.x(), 100), y: safeNum(e.target.y(), 100) })}
                  onDragEnd={e => updateLayer(layer.id, { x: safeNum(e.target.x(), 100), y: safeNum(e.target.y(), 100) })}
                  perfectDrawEnabled={false}
                  listening={true}
                />
              );
            }
            // ---- GIF ----
            if (layer.type === "gif" && isLayerVisible(layer)) {
              return (
                <MyImage
                  key={layer.id}
                  ref={node => layerRefs.current[layer.id] = node}
                  src={layer.content}
                  x={safeNum(layer.x, 100)}
                  y={safeNum(layer.y, 100)}
                  width={safeNum(layer.width, 320)}
                  height={safeNum(layer.height, 180)}
                  draggable
                  opacity={safeNum(layer.opacity, 1)}
                  rotation={safeNum(layer.rotation, 0)}
                  onClick={() => setSelectedId(layer.id)}
                  onTap={() => setSelectedId(layer.id)}
                  onMouseEnter={e => {
                    e.target.getStage().container().style.cursor = 'move';
                  }}
                  onMouseLeave={e => {
                    e.target.getStage().container().style.cursor = 'default';
                  }}
                  onTransformEnd={e => {
                    const node = e.target;
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();
                    let width = safeNum(node.width() * scaleX, 10);
                    let height = safeNum(node.height() * scaleY, 10);
                    updateLayer(layer.id, {
                      x: safeNum(node.x(), 100),
                      y: safeNum(node.y(), 100),
                      width,
                      height,
                      rotation: safeNum(node.rotation(), 0),
                    });
                    node.scaleX(1); node.scaleY(1);
                  }}
                  onDragMove={e => updateLayer(layer.id, { x: safeNum(e.target.x(), 100), y: safeNum(e.target.y(), 100) })}
                  onDragEnd={e => updateLayer(layer.id, { x: safeNum(e.target.x(), 100), y: safeNum(e.target.y(), 100) })}
                  perfectDrawEnabled={false}
                  listening={true}
                  imageSmoothingEnabled={false}
                  imageSmoothingQuality="high"
                />
              );
            }
            // ---- VIDEO ----
            if (layer.type === "video" && isLayerVisible(layer)) {
              return (
                <rect
                  key={layer.id}
                  ref={node => layerRefs.current[layer.id] = node}
                  x={safeNum(layer.x, 100)}
                  y={safeNum(layer.y, 100)}
                  width={safeNum(layer.width, 320)}
                  height={safeNum(layer.height, 180)}
                  fill="#202024"
                  opacity={0.3}
                  stroke="#ac76f4"
                  strokeWidth={2}
                  draggable
                  rotation={safeNum(layer.rotation, 0)}
                  onClick={() => setSelectedId(layer.id)}
                  onTap={() => setSelectedId(layer.id)}
                  onMouseEnter={e => {
                    e.target.getStage().container().style.cursor = 'move';
                  }}
                  onMouseLeave={e => {
                    e.target.getStage().container().style.cursor = 'default';
                  }}
                  onTransformEnd={e => {
                    const node = e.target;
                    const scaleX = node.scaleX();
                    const scaleY = node.scaleY();
                    let width = safeNum(node.width() * scaleX, 10);
                    let height = safeNum(node.height() * scaleY, 10);
                    updateLayer(layer.id, {
                      x: safeNum(node.x(), 100),
                      y: safeNum(node.y(), 100),
                      width,
                      height,
                      rotation: safeNum(node.rotation(), 0),
                    });
                    node.scaleX(1); node.scaleY(1);
                  }}
                  onDragMove={e => updateLayer(layer.id, { x: safeNum(e.target.x(), 100), y: safeNum(e.target.y(), 100) })}
                  onDragEnd={e => updateLayer(layer.id, { x: safeNum(e.target.x(), 100), y: safeNum(e.target.y(), 100) })}
                  perfectDrawEnabled={false}
                  listening={true}
                />
              );
            }
            return null;
          })}
          {selectedId && layerRefs.current[selectedId] && (
            <Transformer
              ref={transformerRef}
              anchorSize={10}
              borderDash={[4, 4]}
              enabledAnchors={[
                'top-left', 'top-right', 'bottom-left', 'bottom-right',
                'middle-left', 'middle-right', 'top-center', 'bottom-center'
              ]}
              rotateEnabled={true}
              boundBoxFunc={(oldBox, newBox) => newBox}
            />
          )}
        </Layer>
      </Stage>
    </div>
  );
}
